import axios from 'axios';
/**
 * @namespace
 */

let version = {};


/**
 *获取最新app版本
 *
 * @param {Object} params
 * @param params.team_id  团队ID
 * @returns {Object}
 */

version.getInfo = async function(){
    var url
    if(window.system === 'android') {
        console.log('[当前系统：Android]')
        url = '/project/app_version?apptype=Android'
    }
    else if(window.system === 'ios') {
        console.log('[当前系统：IOS]')
        url = '/project/app_version?apptype=iPhone'
    }
    try{
        let res = await axios.get(url);
        return res.data?res.data:res;
    }catch(err){
        console.log(err);
    }
}

export default version;